import { MY_STORE_BUTTON_LABEL, SET_STORE_BUTTON_CLASS, SET_STORE_BUTTON_LABEL, } from '../constants/store.constants';
import { extractCollectionHandleFromUrl, selectStoreManually, selectedStoreState, } from '../services/store.service';
import '../../styles/pages/_store-locator.scss';
const REBUILD_MAX_ATTEMPTS = 600;
const REBUILD_INTERVAL_MS = 100;
let zipWasPopulated = false;
function isSelectMyStoreButtonEnabled() {
    return window.UNTUCKitConfig?.nearbyToggle?.selectMyStoreFunctionalityToggle === true;
}
function loadStoremapperWidget() {
    const storemapperEl = document.getElementById('storemapper');
    const start = storemapperEl?.dataset.storemapperStart ?? '';
    const id = storemapperEl?.dataset.storemapperId;
    if (!id) {
        console.error('[store-locator] Missing storemapper_id setting');
        return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = `${document.location.protocol}//www.storemapper.co/js/widget.js`;
    script.dataset.storemapperStart = start;
    script.dataset.storemapperId = id;
    const entry = document.getElementsByTagName('script')[0];
    entry.parentNode?.insertBefore(script, entry);
}
function reorderListItemElements(listItem) {
    const website = listItem.querySelector('.storemapper-url');
    const btnWrap = listItem.querySelector('.storemapper_btn-wrap');
    const custom1 = listItem.querySelector('.storemapper-custom-1');
    const custom2 = listItem.querySelector('.storemapper-custom-2');
    const custom3 = listItem.querySelector('.storemapper-custom-3');
    const description = listItem.querySelector('.storemapper-description');
    [custom1, custom2, custom3, description, btnWrap].forEach((el) => {
        if (el) {
            listItem.appendChild(el);
        }
    });
    if (btnWrap && website) {
        btnWrap.appendChild(website);
    }
}
function getStoreHandleFromListItem(listItem) {
    const urlLink = listItem.querySelector('.storemapper-url a[href]');
    if (!urlLink?.href) {
        console.error('[store-locator] Unable to derive collection handle for store list item', listItem);
        return null;
    }
    const handle = extractCollectionHandleFromUrl(urlLink.href);
    if (!handle) {
        console.error('[store-locator] Unable to parse collection handle from URL', urlLink.href);
    }
    return handle;
}
function updateSetStoreButtonState(button, handle, selectedHandle) {
    const isSelected = selectedHandle === handle;
    button.textContent = isSelected ? MY_STORE_BUTTON_LABEL : SET_STORE_BUTTON_LABEL;
    button.disabled = isSelected;
    button.setAttribute('aria-pressed', String(isSelected));
}
function updateAllSetStoreButtons(selectedHandle) {
    document.querySelectorAll(`.${SET_STORE_BUTTON_CLASS}`).forEach((button) => {
        const handle = button.dataset.storeHandle;
        if (handle) {
            updateSetStoreButtonState(button, handle, selectedHandle);
        }
    });
}
async function handleSetStoreClick(handle, button) {
    if (button.disabled) {
        return;
    }
    button.disabled = true;
    try {
        await selectStoreManually(handle);
    }
    catch (e) {
        console.error('[store-locator] Failed to set selected store', e);
        updateSetStoreButtonState(button, handle, selectedStoreState.get()?.COLLECTION_HANDLE ?? null);
    }
}
function injectSetStoreButton(listItem, handle, selectedHandle) {
    const btnWrap = listItem.querySelector('.storemapper_btn-wrap');
    if (!btnWrap) {
        return;
    }
    let button = btnWrap.querySelector(`.${SET_STORE_BUTTON_CLASS}`);
    if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = SET_STORE_BUTTON_CLASS;
        button.addEventListener('click', () => {
            const storeHandle = button?.dataset.storeHandle;
            if (storeHandle) {
                void handleSetStoreClick(storeHandle, button);
            }
        });
        btnWrap.appendChild(button);
    }
    button.dataset.storeHandle = handle;
    updateSetStoreButtonState(button, handle, selectedHandle);
}
function injectSetStoreButtons() {
    if (!isSelectMyStoreButtonEnabled()) {
        return;
    }
    const selectedHandle = selectedStoreState.get()?.COLLECTION_HANDLE ?? null;
    document.querySelectorAll('#storemapper-list li').forEach((listItem) => {
        const handle = getStoreHandleFromListItem(listItem);
        if (handle) {
            injectSetStoreButton(listItem, handle, selectedHandle);
        }
    });
}
function rebuildMapItems() {
    let attempts = 0;
    const interval = window.setInterval(() => {
        attempts += 1;
        const addresses = document.querySelectorAll('.storemapper-address');
        if (addresses.length) {
            addresses.forEach((addressEl) => {
                const listItem = addressEl.closest('li');
                if (listItem) {
                    reorderListItemElements(listItem);
                }
            });
            injectSetStoreButtons();
            window.clearInterval(interval);
            return;
        }
        if (attempts >= REBUILD_MAX_ATTEMPTS) {
            window.clearInterval(interval);
        }
    }, REBUILD_INTERVAL_MS);
}
function populateZipFromQueryParam() {
    const zip = new URLSearchParams(window.location.search).get('zip');
    if (!zip || zipWasPopulated) {
        return;
    }
    zipWasPopulated = true;
    const zipInput = document.getElementById('storemapper-zip');
    const goButton = document.getElementById('storemapper-go');
    if (zipInput && goButton) {
        zipInput.value = zip;
        goButton.click();
    }
}
function storemapperAfterSearchResult() {
    const leftPanel = document.getElementById('storemapper-left');
    if (leftPanel) {
        leftPanel.scrollTop = 0;
    }
    rebuildMapItems();
}
function storemapperCallback() {
    rebuildMapItems();
    populateZipFromQueryParam();
}
function registerStoremapperCallbacks() {
    window.storemapper_callback = storemapperCallback;
    window.storemapper_after_search_result = storemapperAfterSearchResult;
    window.storemapper_after_search = () => undefined;
}
function initStoreLocator() {
    registerStoremapperCallbacks();
    loadStoremapperWidget();
    if (isSelectMyStoreButtonEnabled()) {
        selectedStoreState.subscribe((store) => {
            updateAllSetStoreButtons(store?.COLLECTION_HANDLE ?? null);
        });
    }
    document.addEventListener('click', (e) => {
        if (e.target instanceof Element && e.target.classList.contains('strmpr-view-more-stores-button')) {
            rebuildMapItems();
        }
    });
}
initStoreLocator();
export { rebuildMapItems, getStoreHandleFromListItem, injectSetStoreButtons, extractCollectionHandleFromUrl, };
